const PagesResourceIds: { [key: string]: string } = {
    CENTRAL_NOTAS: 'br.com.sankhya.com.mov.CentralNotas',
}

export default PagesResourceIds;
